import * as React from "react";
import {Calendar, momentLocalizer} from "react-big-calendar";
import * as moment from "moment";
import 'moment/locale/de';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {BigCalendarDetail} from "./BigCalendarDetail";
import {LoaderSpinner} from "./LoaderSpinner";

const localizer = momentLocalizer(moment);

interface BigCalendarProps {
    events: any[];
    calendarId: string;
    showDetails: boolean;
}

interface BigCalendarState {
    events: any[];
    loading: boolean;
}

/**
 * Big calendar for events.
 */
export class BigCalendar extends React.Component<BigCalendarProps, BigCalendarState> {

    state: {
        events: any[],
        loading: boolean,
    };

    private bigCalendarDetail: BigCalendarDetail;

    constructor(props: any) {
        super(props);

        this.state = {
            events: this.props.events,
            loading: false
        }
    }

    /**
     * set the is checked state.
     * @param isChecked
     */
    public getMessages = () => {
        return {
            previous: 'Vorherige',
            next: 'Nächste',
            today: 'Heute',
            month: 'Monat',
            week: 'Woche',
            day: 'Tag',
            allDay: 'ganztägig',
            date: 'Datum',
            time: 'Zeit',
            event: 'Termin',
            yesterday: 'Gestern',
            tomorrow: 'Morgen',
            work_week: 'Kalenderwoche',
            noEventsInRange: 'Keine Termine gefunden',
            showMore: (more: number) => {
                return more + ' mehr';
            }
        }
    };

    /**
     * fetch events per ajax from backend and set it into the calendar.
     * @param range
     *
     */
    public setEvents = (range: any) => {
        // busy dialog

        let start: any = undefined, end: any = undefined;
        // get start and end date from range
        if (range) {
            if (range.start && range.end) {
                start = range.start;
                end = range.end;
            } else if (range.length === 1) {
                start = range[0];
                end = moment(start).add('1', 'day').toDate();
            } else {
                start = range[0];
                end = range[range.length - 1];
            }
        }

        // if start and end found
        if (start && end) {
            this.setState({loading: true}, () => {
                let urlParam = new URLSearchParams();
                urlParam.append("action", "exchange_events");
                urlParam.append("calendarId", this.props.calendarId);
                urlParam.append("start", moment(start).format('YYYY-MM-DD H:mm'));
                urlParam.append("end", moment(end).format('YYYY-MM-DD H:mm'));
                fetch("/wp-admin/admin-ajax.php", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                    },
                    body: urlParam,
                    credentials: 'same-origin'
                })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            if (result && result.success) {
                                let eventList: any[] = [];
                                result.data.map((event: any) => {
                                    event.start = moment(event.start.date).toDate();
                                    event.end = moment(event.end.date).toDate();
                                    eventList.push(event);
                                });
                                this.setState({
                                    events: eventList
                                })
                            }
                            this.setState({loading: false});
                        },
                        (error) => {
                            this.setState({loading: false});
                            console.log(error);
                        }
                    )
            })
        }
    };

    render() {
        return <div className={"exchange"}>
            <Calendar className={this.state.loading ? 'bigCalendarLoading' : ''}
                      localizer={localizer}
                      events={this.state.events}
                      messages={this.getMessages()}
                      onRangeChange={this.setEvents.bind(this)}
                      onSelectEvent={(event) => {
                          this.setState({
                              loading: true
                          });
                          this.bigCalendarDetail.setEventDetails(event, this.props.calendarId);
                      }}/>
            <BigCalendarDetail showDetails={this.props.showDetails} ref={(ref) => this.bigCalendarDetail = ref} onLoaded={() => {
                this.setState({loading: false});
            }}/>
            <div className={'loadingSpinner'}>
                {this.state.loading &&
                <LoaderSpinner/>
                }
            </div>
        </div>
    }
}
